module.exports = __webpack_public_path__ + "static/media/ch-publishing.3c4577f6.jpg";